import { Component, ChangeDetectionStrategy, Inject, ViewChild, TemplateRef,OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ViewEncapsulation } from '@angular/core';
import { scheduleService } from '../../../service/schedule.service';
import { commonService } from '../../../service/common.service';

import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {ActivatedRoute} from "@angular/router";
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours
} from 'date-fns';
import { Subject } from 'rxjs/Subject';

import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent
} from 'angular-calendar';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  }
};
@Component({
  selector: 'app-ucalendar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ucalendar.component.html',
  styleUrls: ['./ucalendar.component.css'],
  encapsulation: ViewEncapsulation.None ,
  providers:[scheduleService,commonService]

})
export class UcalendarComponent implements OnInit {
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  constructor(private modal: NgbModal, @Inject(DOCUMENT) doc: any, private scheduleObj: scheduleService,private router:Router,private route: ActivatedRoute,private common:commonService) {



  }
allevents:any;
modalData: {
  action: string,
  event: CalendarEvent
};
events:any;
msg="";

  ngOnInit() {
    this.getEventList();
  }

  view = 'month';
  viewDate: Date = new Date();

  actions: CalendarEventAction[] = [{
    label: '<i class="fa fa-fw fa-pencil text-white"></i>',
    onClick: ({event}: {event: CalendarEvent}): void => {
      this.handleEvent('Edited', event);
    }
  }, {
    label: '<i class="fa fa-fw fa-times  text-white"></i>',
    onClick: ({event}: {event: CalendarEvent}): void => {
      this.events = this.events.filter(iEvent => iEvent !== event);
      this.handleEvent('Deleted', event);
    }
  }];

  refresh: Subject<any> = new Subject();

  activeDayIsOpen = false;

  dayClicked({date, events}: {date: Date, events: CalendarEvent[]}): void {
    
  // return false;
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
    this.refresh.next();
  }

  eventTimesChanged({event, newStart, newEnd}: CalendarEventTimesChangedEvent): void {
    event.start = newStart;
    event.end = newEnd;
    this.handleEvent('Dropped or resized', event);
    this.refresh.next();
  }

  handleEvent(action: string, event: CalendarEvent): void {
   // this.modalData = {event, action};
    //this.modal.open(this.modalContent, {size: 'lg'});
  }

  addEvent(): void {
  
  }

  getEventList(){
    var obj={};
    obj['uid']=this.common.user.id;
    this.scheduleObj.schedulelistByUser(obj).subscribe((data:any)=>{
     
      this.allevents=[];
      if(data.error==0){
      for(let i in data.results){     
        //console.log(data.results[i]);
        var title='<div class="title-box"><div> <strong>Course Name :</strong>'+data.results[i].course.courseName+'</div> <div><strong>Subject Name :</strong>'+data.results[i].subject.subjectName+'</div> <div><strong>Venue Name :</strong>'+data.results[i].venue.venueName+'</div><div><strong>Instructor : </strong>'+data.results[i].user.firstName+' '+data.results[i].user.lastName+' </div></div>';   
        var date=new  Date(data.results[i].date);
        var startDate,EndDate;
        startDate=EndDate=date;

        var timestr=data.results[i].starttime;
        if(timestr){
          var timeArr=timestr.split(":");        
          startDate.setHours(parseInt(timeArr[0]));
          startDate.setMinutes(parseInt(timeArr[1]));
          startDate.setSeconds(parseInt(timeArr[2]));        
        }
        var timestr=data.results[i].endtime;
        if(timestr){
          var timeArr=timestr.split(":");         
          EndDate.setHours(parseInt(timeArr[0]));
          EndDate.setMinutes(parseInt(timeArr[1]));
          EndDate.setSeconds(parseInt(timeArr[2]));
          
        }
        var tmpobj={};
        tmpobj['start']=startDate;
        tmpobj['end']=EndDate;
        tmpobj['title']=title;
        tmpobj['color']=colors.yellow;
        this.allevents.push(tmpobj);
      }
      
        this.events = this.allevents;
        this.refresh.next();
      }else{


      }


    },(error:HttpErrorResponse)=>{

        this.msg="internal server error!";

    });
    
  }
 
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/uprofile/ucalendar/ucalendar.component.ts